/* ka-i18n（2026-10 海外対応）：英語などのページだけ #ka-i18n-dictionary の訳を使う。日本語のページでは辞書がないので、元の日本語をそのまま返す。 */
var kaT = (typeof window !== 'undefined' && window.kaT) || (function () {
  var dict;
  function load() { if (dict === undefined) { var el = document.getElementById('ka-i18n-dictionary'); if (!el) return null; try { dict = JSON.parse(el.textContent); } catch (e) { dict = null; } } return dict; }
  var f = function (key, ja) { var d = load(); return d && Object.prototype.hasOwnProperty.call(d, key) ? d[key] : ja; };
  f.on = function () { return !!load(); };
  f.val = function (v) { var d = load(); if (!d) return v; var m = d['kawaii.js.values_html']; if (typeof m === 'string') { try { m = d['kawaii.js.values_html'] = JSON.parse(m); } catch (e) { m = {}; } } return (m && m[v]) || v; };
  // 長い HTML の文は、日本語の部分だけを1つずつ訳に置き換える（言語ファイルの1つの値の長さに上限があるため）
  f.rep = function (s, pairs) { if (!load()) return s; for (var i = 0; i < pairs.length; i++) s = s.split(pairs[i][0]).join(f(pairs[i][1], pairs[i][0])); return s; };
  f.money = function (cents) { var c = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'; return new Intl.NumberFormat('en-US', { style: 'currency', currency: c }).format(cents / 100); };
  window.kaT = f; return f;
})();
/* KAWAII ART：スマホ上部カートの数字（空なら非表示）と、商品ページの下に付くカートボタン（2026-09-23） */
(() => {
  'use strict';

  /* ---- 上部カートの赤い数字：0件のときは丸ごと隠す（どのページでも。9/24からPCの数も） ---- */
  const syncBadge = () => {
    document.querySelectorAll('.ss-topbar .ss-cart-count, .secondary-nav__item--cart .cart-count-bubble').forEach((badge) => {
      const n = parseInt((badge.textContent || '').trim(), 10);
      badge.classList.toggle('is-empty', !(n > 0));
    });
  };
  const watchBadge = () => {
    syncBadge();
    document.querySelectorAll('.ss-topbar .ss-cart-count, .secondary-nav__item--cart .cart-count-bubble').forEach((badge) => {
      new MutationObserver(syncBadge).observe(badge, { childList: true, characterData: true, subtree: true });
    });
  };
  // 「戻る」で前の画面が復元されたときのカートの取り直しは cart-components.js（テーマのカート情報）で一括して行う。
  // 上部の数はそのカート情報から cart-link.js が書き換えるので、ここでは 0 のときに丸を隠すだけ。

  /* ---- 商品ページの下に付くカートボタン ---- */
  const LINE_URL = 'https://page.line.me/476eqyhz';
  const mq = window.matchMedia('(max-width: 767px)');
  const SHOW_AFTER = 240; // 少しスクロールしてから表示（px）
  // 通常作品（8作家）とミニで購入欄の入れ物のクラスが違う
  const REGION_BTN = '.ka-artwork-purchase-region .product-form__add-btn, .ka-mini-price-list .product-form__add-btn';

  const setupBar = () => {
    const main = document.querySelector(REGION_BTN);
    if (!main || document.querySelector('.ka-sab')) return;

    const bar = document.createElement('div');
    bar.className = 'ka-sab';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', kaT('kawaii.js.sticky_cart_add_to_cart_html', 'カートに入れる'));
    const lineLogo = document.querySelector('.ss-line-logo');
    if (kaT.on()) bar.classList.add('ka-sab--intl');
    bar.innerHTML = kaT.on() ? kaT('kawaii.js.sab_add_html', '<button type="button" class="ka-sab__add">カートに入れる</button>') :
      `<a class="ka-sab__line" href="${LINE_URL}" target="_top" rel="noopener noreferrer" aria-label="LINEで問い合わせる">` +
      (lineLogo ? `<img src="${lineLogo.currentSrc || lineLogo.src}" width="24" height="24" alt="">` : '') +
      '<span>問い合わせ</span></a>' +
      '<button type="button" class="ka-sab__add">カートに入れる</button>';
    document.body.appendChild(bar);
    const add = bar.querySelector('.ka-sab__add');

    // 見た目は上部の「カートに入れる」ボタンと同じ色・書体にそろえる（角丸はバー内の「問い合わせ」に合わせてCSSで8px）
    // 上部ボタンは読み込み直後に色が切り替わる（CSSの変化の途中がある）ため、表示するたびに写し直す
    const syncLook = () => {
      const cs = getComputedStyle(main);
      bar.style.setProperty('--ka-sab-bg', cs.backgroundColor);
      bar.style.setProperty('--ka-sab-color', cs.color);
      bar.style.setProperty('--ka-sab-font', cs.fontFamily);
    };
    syncLook();
    main.addEventListener('transitionend', syncLook);

    const syncDisabled = () => { add.disabled = !!main.disabled; };
    new MutationObserver(syncDisabled).observe(main, { attributes: true, attributeFilter: ['disabled'] });
    syncDisabled();

    // 押したら、上部の「カートに入れる」と同じ処理（入力の小窓・カートへの移動もそのまま）
    add.addEventListener('click', () => { if (!main.disabled) main.click(); });

    // 表示の切り替え：少しスクロールしていて、上部のボタンが画面に見えていないとき
    let mainVisible = false;
    const setH = () => document.documentElement.style.setProperty('--ka-sab-h', `${bar.offsetHeight}px`);
    // 名前入れの小窓（dialog）やメニュー（role=dialog）が開いている間は隠す
    const overlayOpen = () => !!document.querySelector('dialog[open], [role="dialog"][aria-modal="true"]:not([aria-hidden="true"])');
    const update = () => {
      const on = mq.matches && window.scrollY > SHOW_AFTER && !mainVisible && !overlayOpen();
      if (bar.classList.contains('is-visible') === on) return; // 変化がないときは何もしない（監視との空回り防止）
      if (on) syncLook();
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      bar.inert = !on;
      document.body.classList.toggle('ka-sab-on', on);
    };
    new IntersectionObserver((entries) => {
      entries.forEach((e) => { mainVisible = e.isIntersecting; });
      update();
    }).observe(main);
    window.addEventListener('scroll', update, { passive: true });
    // バー自身の属性変更は無視する（自分の aria-hidden で自分を呼び続けないように）
    new MutationObserver((records) => { if (records.some((r) => !bar.contains(r.target))) update(); })
      .observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open', 'aria-hidden'] });
    mq.addEventListener?.('change', () => { setH(); update(); });
    window.addEventListener('resize', setH);
    window.addEventListener('pageshow', (e) => { if (e.persisted) { syncDisabled(); update(); } });
    document.body.classList.add('ka-sab-ready');
    bar.setAttribute('aria-hidden', 'true');
    bar.inert = true;
    setH();
    update();
  };

  // 購入欄は各作家のJSが後から整えるため、ボタンが見つかるまで少し待つ（最大約15秒）
  const setupBarWhenReady = (tries = 0) => {
    if (document.querySelector('.ka-sab')) return;
    if (document.querySelector(REGION_BTN)) { setupBar(); return; }
    if (!document.querySelector('.product-form__add-btn') || tries >= 50) return;
    setTimeout(() => setupBarWhenReady(tries + 1), 300);
  };
  const init = () => {
    watchBadge();
    setupBarWhenReady();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
